import Vue from 'vue';
import unitOfMeasureTransformer from './../../transformers/unitOfMeasure';
import store from '../../store';

const success = ({ data }, resolve) => {
  const unitOfMeasure = unitOfMeasureTransformer.fetch(data);
  resolve(unitOfMeasure);
  store.dispatch('fetchCurrentUnitOfMeasure', unitOfMeasure);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/unit_of_measures/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/unitOfMeasure/show.js